module.exports = __webpack_public_path__ + "img/bundit_b.3eeec0ee.webp";